
export enum CubicFeetProfileTypeCd {
	DENSITY_SHIPMENT = 'Density shipment',
	FOOTPRINT_PIECE_PROFILE = 'Footprint piece profile',
	HEIGHT_PIECE = 'Height piece',
	UNDEFINED = 'Undefined',
	VOLUME_PIECE = 'Volume-piece',
	VOLUME_SHIPMENT = 'Volume-shipment'}

